var styleDataHash = "b93bd9b7";
const injectCss = (() => {
  var css = `.L3cbw,.zHzcc{height:386px;margin-right:-16px;margin-top:20px;overflow:auto;padding-right:16px}.L3cbw._6QekS,.zHzcc._6QekS{height:calc(100vh - 190px)}.JwwR3{display:flex;flex-direction:column}.gznvN{float:right;text-align:right}.chwUa{cursor:pointer}.chwUa:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.OlOCO{margin-top:50px}.OlOCO,.cHU50{height:100%;width:100%}.OlOCO,.cHU50,.zHzcc{align-items:center;display:flex;justify-content:center}.zHzcc{max-width:100%}.MAw2m{--wds-input-value-font-size-medium:14px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var giphy_selector_default = {
  "giphy_selector_infinite_scroll_container": "L3cbw",
  "giphySelectorErrorContainer": "zHzcc",
  "mobile": "_6QekS",
  "giphy_selector_infinite_scroll": "JwwR3",
  "giphy_selector_powerdByGiphy": "gznvN",
  "giphy_selector_gif_img_container": "chwUa",
  "giphy_selector_spinner_load_more": "OlOCO",
  "giphy_selector_spinner_empty_modal": "cHU50",
  "searchInput": "MAw2m"
};
export {
  giphy_selector_default as default,
  injectCss
};
//# sourceMappingURL=giphy-selector-scss.js.map
